export function parseApiDateString(dateString) {
  if (!dateString || typeof dateString !== "string") {
    return null;
  }
  const parts = dateString.split("-");
  if (parts.length !== 3) {
    return null;
  }
  const date = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
  return Number.isNaN(date.getTime()) ? null : date;
}

/**
 * Contract End Date = API anniversaryDate.
 * Contract Start Date = API contractStartDate when present, else anniversaryDate - 365 days.
 */
export function getContractDates(anniversaryDate, contractStartDate) {
  const endDate = parseApiDateString(anniversaryDate);
  if (!endDate) {
    return {};
  }

  const apiStartDate = parseApiDateString(contractStartDate);
  let startDate;
  if (apiStartDate) {
    startDate = apiStartDate;
  } else {
    startDate = new Date(endDate.toString());
    startDate.setDate(startDate.getDate() - 365);
  }

  return {
    anniversaryDate: startDate.toLocaleDateString(),
    contractEndDate: endDate.toLocaleDateString(),
  };
}
